/**
 * Created by Jo on 14/07/17.
 */

$(document).ready(function(){
    if($("[name=company]").length > 0){
        $("[name=company]").data("optional", $("[name=company]").prop("placeholder"));
        $("[name=vat_number]").data("optional", $("[name=vat_number]").prop("placeholder"));
        $("[name=vat_number]").data("lastValue", $("[name=vat_number]").val());

        keyupOnCompany();

        $("[name=company]").keyup(keyupOnCompany);
    }
});


function keyupOnCompany(){
    if($("[name=company]").val() !== undefined && $("[name=company]").val() != ""){
        $("[name=vat_number]").prop("required", true);
        $("[name=vat_number]").prop("disabled", false);
        $("[name=vat_number]").prop("placeholder", $("[name=vat_number]").data("optional") + "*");
    } else {
        $("[name=vat_number]").data("lastValue", $("[name=vat_number]").val());
        $("[name=vat_number]").val("");
        $("[name=vat_number]").prop("disabled", true);
        $("[name=vat_number]").prop("placeholder", $("[name=vat_number]").data("optional"));
    }
}


// WEBPACK FOOTER //
// ./js/jo.js